// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"7213179a","974":"5a0b8bbf"}[chunkId] + ".chunk.js";
};